module.exports = __webpack_public_path__ + "img/img-img.cb7f1e22.png";